import { render } from "./ClientUpdate.vue?vue&type=template&id=b570d4da"
import script from "./ClientUpdate.vue?vue&type=script&lang=js"
export * from "./ClientUpdate.vue?vue&type=script&lang=js"

import "../../../src/assets/css/multSelect.css?vue&type=style&index=0&lang=css"
import "../../../src/assets/css/formTab.css?vue&type=style&index=1&lang=css"
import "../../../src/assets/css/avatar.css?vue&type=style&index=2&lang=css"
import "./ClientUpdate.vue?vue&type=style&index=3&id=b570d4da&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__